// Copyright (c) 2022 Deere & Company

import PercentageDebitInfoPanel from './percentage-debit-info-panel';
import actionCreators from '../../action-creators';
import {buildDealer} from '../../../../shared/services/build-dealer';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claimNumber: state.tcsm.percentageDebit.debit.claimNumber,
    claimSubType: state.tcsm.percentageDebit.debit.subClaimType,
    claimType: state.tcsm.percentageDebit.debit.claimType,
    dealerLocation: buildDealer(state.tcsm.percentageDebit.debit.responsibleAccount),
    netAmountPaid: state.tcsm.percentageDebit.debit.netAmountPaid,
    pin: state.tcsm.percentageDebit.debit.pin
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    routeParams: parentProps.routeParams
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PercentageDebitInfoPanel);



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/components/percentage-debit-info-panel/index.js